export default __webpack_public_path__ + "static/sj-89085b7802da8ea60f4a0fc009c631b2.svg";